import { UpdateLicenseDto } from '../../pages/users/api/dto/update/UpdateLicenseDto'
import { UpdateLicenseUI } from '../../pages/users/model/UpdateLicenseUI'
import { UpdateLicensesUI } from '../../pages/users/model/UpdateLicensesUI'
import License from './License'
import Licenses from './Licenses'
import UpdateLicense from './UpdateLicense'

class UpdateLicenses {
  private constructor(licenses: UpdateLicense[]) {
    this.licenses = licenses
  }

  private readonly licenses: UpdateLicense[]

  findLicense(id: string): UpdateLicense {
    const license = this.licenses.find((license: UpdateLicense) =>
      license.hasId(id),
    )

    if (license === undefined) {
      throw Error('Message here...')
    }

    return license
  }

  addLicense(id: string): void {
    const license = this.findLicense(id)
    license.setActive(true)
  }

  removeLicense(id: string): void {
    const license = this.findLicense(id)
    license.setActive(false)
  }

  updateLicense(updateLicense: UpdateLicense): void {
    const license = this.findLicense(updateLicense.getId())
    license.update(updateLicense)
  }

  toDto(): UpdateLicenseDto[] {
    return this.licenses
      .filter((updateLicense: UpdateLicense) => updateLicense.isActive())
      .map((updateLicense: UpdateLicense) => updateLicense.toDto())
  }

  toUI(): UpdateLicensesUI {
    return {
      licenses: this.licenses.map((license: UpdateLicense) => license.toUI()),
    } satisfies UpdateLicensesUI
  }

  static fromUpdateLicensesUI(
    updateLicenses: UpdateLicensesUI,
  ): UpdateLicenses {
    const licenses = updateLicenses.licenses.map(
      (updateLicenseUI: UpdateLicenseUI) =>
        UpdateLicense.fromUpdateLicenseUI(updateLicenseUI),
    )

    return new UpdateLicenses(licenses)
  }

  static fromLicenses(licenses: Licenses): UpdateLicenses {
    const updateLicenses = licenses
      .getAll()
      .map((license: License) => UpdateLicense.fromLicense(license))

    return new UpdateLicenses(updateLicenses)
  }
}

export default UpdateLicenses
